<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="error-wrapper">
    <div
      class="contents-container"
      [ngClass]="{
        'transparent-no-border': state.interruptionDetails?.ctaBlackLabel
      }"
    >
      <app-zaver-icon *ngIf="state.interruptionDetails?.displayBankIcon" class="icon-user-img" [size]="80" name="bankSignalCircle"></app-zaver-icon>

      <p class="heading">{{ state.interruptionDetails?.heading }}</p>
      <p
        class="info-text"
        *ngIf="!!state.interruptionDetails?.message"
        [innerHTML]="
          state.interruptionDetails?.message.replace(
            '{amount}',
            state.totalCheckoutValue | value
          )
        "
      ></p>

      <div class="button-wrapper">
        <zaver-primary-button
          *ngIf="state.interruptionDetails?.ctaBlackLabel"
          [text]="state.interruptionDetails.ctaBlackLabel"
          [disabled]="navigationInProgress"
          (click)="handleUpdateWebFormCtaClick()"
        ></zaver-primary-button>

        <zaver-secondary-button-outlined
          *ngIf="state.interruptionDetails?.ctaLabel"
          [text]="state.interruptionDetails.ctaLabel"
          [disabled]="navigationInProgress"
          (click)="handleCtaClick()"
        ></zaver-secondary-button-outlined>
      </div>

      <a
        *ngIf="state.interruptionDetails?.linkLabel"
        class="navigation-link"
        disabled="navigationInProgress"
        [text]="state.interruptionDetails?.linkLabel"
        (click)="handleLinkClick()"
      ></a>
    </div>
  </div>
</div>
